package com.example.monetix


/**
 * Converte i centesimi in una stringa formattata (es: 1250 -> "12,50 €")
 */
fun formatEuroFromCents(cents: Long): String {
    val absCents = kotlin.math.abs(cents)
    val euros = absCents / 100
    val decimals = (absCents % 100).toString().padStart(2, '0')
    val sign = if (cents < 0) "-" else ""
    return "$sign€ $euros,$decimals"
}

/**
 * Rimuove i marcatori di sistema tra parentesi quadre dai nomi (es: "Conto [banca]" -> "Conto")
 */
fun stripSystemMarker(name: String?): String? {
    if (name == null) return null
    val cleaned = name.replace(Regex("\\[.*?\\]"), "").trim()
    return cleaned.ifBlank { null }
}

/**
 * Pulisce l'input dell'utente per gli importi euro
 */
fun normalizeEuroInput(input: String): String {
    return input.replace(",", ".").filter { it.isDigit() || it == '.' }
}

/**
 * Converte una stringa "12.50" in centesimi Long (1250)
 */
fun parseEuroToCents(input: String): Long {
    val normalized = normalizeEuroInput(input)
    return try {
        (normalized.toDouble() * 100).toLong()
    } catch (e: Exception) {
        0L
    }
}

/**
 * Ordina una lista di oggetti in base a un ordine di ID salvato
 */
fun <T> applyIdOrder(
    list: List<T>,
    idOf: (T) -> String,
    orderedIds: List<String>
): List<T> {
    if (orderedIds.isEmpty()) return list
    val idToIndex = orderedIds.withIndex().associate { it.value to it.index }
    return list.sortedWith(compareBy { idToIndex[idOf(it)] ?: Int.MAX_VALUE })
}

// Nota: loadAccountOrderIds e saveAccountOrderIds li gestiremo
// più avanti con le impostazioni (Settings/DataStore)
fun loadAccountOrderIds(context: Any?): List<String> = emptyList()
fun saveAccountOrderIds(context: Any?, ids: List<String>) {}
/**
 * Normalizza il testo per la ricerca globale
 */
fun normalizeKey(input: String): String {
    return input.trim().lowercase()
}